import AxiosInstance from '../config/AxiosInstance';

interface termDetailPayload {
    termCode: string,
    termName: string,
    termDescription: string,
    termDay: number
}

const createTerm = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/terms', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const loadTerm = async (filter: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/terms/list', filter);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailTerm = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/terms/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateTerm = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/terms/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteTerm = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/terms/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createTerm,
    loadTerm,
    getDetailTerm,
    updateTerm,
    deleteTerm
}